import { LoginType } from 'api-types/models/LoginDto';
import { getUserGroups } from './getUserGroups';
import type { SerializableAuthUser } from '../../interfaces/authUser';

export function isOneOfTheFitnessGroups(
    user: SerializableAuthUser | null | undefined
): boolean {
    return [LoginType.COACH, LoginType.MASSAGE, LoginType.PHYSIO].some(
        (loginType) => getUserGroups(user).includes(loginType)
    );
}
